import {
  GET_QUOTATION,
  PRINT_QUOTATION,
  QUOTATION_RECEIVED,
  DISPLAY_QUOTATION_ASSISTANT,
  UPDATE_QUOTATION_STATUS,
} from './constants';

/**
 *
 * @param code
 * @returns {{code: *, type: *}}
 */
export const getQuotation = proposal_id => ({
  type: GET_QUOTATION,
  proposal_id,
});

/**
 *
 * @param id
 * @returns {{id: *, type: *}}
 */
export const printQuotation = id => ({
  type: PRINT_QUOTATION,
  id,
});

/**
 *
 * @param display
 * @returns {{display: *, type: *}}
 */
export const displayAssistant = display => ({
  type: DISPLAY_QUOTATION_ASSISTANT,
  display,
});

/**
 *
 * @param quotation
 * @returns {{type: *, quotation: *}}
 */
export function quotationLoaded(quotation) {
  return {
    type: QUOTATION_RECEIVED,
    quotation,
  };
}

export const updateStatus = newStatus => ({
  type: UPDATE_QUOTATION_STATUS,
  newStatus,
});
